import React from 'react';
import { connect } from 'react-redux';
import {
  Switch,
  NavLink,
  Route,
  Redirect
} from 'react-router-dom';

import { setIsMobile } from './actions/environment.js';
import About from './components/About.jsx';
import InterviewSimulator from './components/Interview.jsx';
import Projects from './components/Projects.jsx';
import api from './api';

import Header from './components/Header.jsx';

class App extends React.Component {
  constructor() {
    super();
  }
  componentDidMount() {
    let isMobile =  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    console.log("isMobile", isMobile, navigator.userAgent);
    this.props.dispatch(setIsMobile(isMobile));
  }
  render() {
    return (
      <React.Fragment>
        <Header/>
        <Switch>
          <Route exact path="/about" component={About} />
          <Route path="/projects" component={Projects} />
          <Route path="/interviewsimulator" component={InterviewSimulator} />
          <Route render={() => <Redirect to="/about" />} />
        </Switch>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state, newProps) => {
  return {
  }
}

export default connect(mapStateToProps)(App);

class NotFound extends React.Component {
  render() {
    return <h1>PAGE NOT FOUND</h1>;
  }
}
